import React, { FC, InputHTMLAttributes, useContext } from 'react';

import { StyledRadioButtonWrapper, StyledHiddenRadioButton } from './RadioButton.styles';
import Bullet from '../_Bullet';
import FormColContext from '../_FormColContext';

export interface RadioButtonProps extends InputHTMLAttributes<HTMLInputElement> {}

const RadioButton: FC<RadioButtonProps> = ({ style, className, readOnly, disabled, ...props }) => {
  const { colId } = useContext(FormColContext);
  return (
    <StyledRadioButtonWrapper
      readOnly={readOnly}
      disabled={disabled}
    >
      <StyledHiddenRadioButton
        type="radio"
        data-testid="RadioButton"
        disabled={disabled || readOnly}
        aria-labelledby={colId}
        {...props}
      />
      <Bullet />
    </StyledRadioButtonWrapper>
  );
};

export default RadioButton;
